// extracted by mini-css-extract-plugin
export default {"section":"LostDamagedPalletsInDeliverySection_section__Vwksf"};